import { Typography, TypographyProps } from '@mui/material'
import { useCurrentStore } from 'hooks'
import { FC, useEffect, useState } from 'react'

export const KCurrentTime: FC<TypographyProps> = (props) => {
  const { currentTime } = useCurrentStore()
  const [time, setTime] = useState<string>(currentTime().format('LTS'))

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(currentTime().format('LTS'))
    }, 1000)
    return () => clearInterval(interval)
  }, [currentTime])
  return <Typography {...props} data-chromatic="ignore">{time}</Typography>
}
